export function dataURLToBlob(dataURL) {
  const BASE64_MARKER = ';base64,';
  if (dataURL.indexOf(BASE64_MARKER) === -1) {
    const parts = dataURL.split(',');
    const contentType = parts[0].split(':')[1];
    const raw = decodeURIComponent(parts[1]);

    return new Blob([raw], { type: contentType });
  }
  const parts = dataURL.split(BASE64_MARKER);
  const contentType = parts[0].split(':')[1];
  const raw = window.atob(parts[1]);
  const rawLength = raw.length;
  const uInt8Array = new Uint8Array(rawLength);
  uInt8Array.forEach((item, key) => {
    uInt8Array[key] = raw.charCodeAt(key);
  });
  return new Blob([uInt8Array], { type: contentType });
}


export function compress(target) {
  return new Promise((res) => {
    const reader = new FileReader();
    reader.readAsDataURL(target);
    reader.onloadend = (file) => {
      const image = new Image();
      image.src = file.target.result;
      image.onload = () => {
        const canvas = document.createElement('canvas');

        let width = image.width;
        let height = image.height;
        const maxWidth = 800;
        const maxHeight = 800;

        // calculate the width and height, constraining the proportions
        if (width > height) {
          if (width > maxWidth) {
            height = Math.round(height *= maxWidth / width);
            width = maxWidth;
          }
        } else if (height > maxHeight) {
          width = Math.round(width *= maxHeight / height);
          height = maxHeight;
        }

        // resize the canvas and draw the image data into it
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(image, 0, 0, width, height);
        // quality = 0.6 - 0.7 (recomended), Max = 1.0 (not recomended)
        res(dataURLToBlob(canvas.toDataURL('image/jpeg', 0.6)));
      };
    };
  });
}



// WEBPACK FOOTER //
// ./src/utils/compress.js